import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { first, mergeMap, map, filter } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AuthState } from '../store/reducers/auth.reducer';
import { AuthCo, AuthCoSilent } from '../store/actions/auth.action';
import { isAuthentified } from '../store/selectors/auth.selector';
import { Go } from '../store/actions/router.action';
import { OidcConfig } from '../conf/conf';

/**
 * C'est le garde à utiliser sur les pages pour les protéger par l'authentification
 */

@Injectable()
export class AuthGuard  {

  store = inject(Store<AuthState>);
  router = inject(Router);
  authService = inject(AuthService);
  config = inject(OidcConfig);

  /**
   * decide if allowed or not
   * @see CanActivate#canActivate
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return this.store.pipe(
        select(isAuthentified),
        first(),
        mergeMap((isAut) => isAut
            ? of(true)
            : this.authService.getUser().pipe(
                    first(),
                    mergeMap((user) => {
                        if (user !== null && !user.expired) {
                            this.store.dispatch(new AuthCoSilent(user));
                            return this.store.select(isAuthentified).pipe(
                              filter(isAuth => isAuth),
                              first(),
                            );
                        } else {
                            const home = this.config.home;
                            if (this.config.redirect) {
                              this.store.dispatch(new AuthCo(state.url));
                            } else {
                              this.store.dispatch( new Go({ path: [home], query: { returnUrl: state.url } }));
                            }
                            return of(false);
                        }
                })
            )
        )
      );
  }
}
